module.exports = __webpack_public_path__ + "static/img/noActivityaa6fa56.png";